import { render } from "./WorldItem.vue?vue&type=template&id=3729d38a"
import script from "./WorldItem.vue?vue&type=script&lang=js"
export * from "./WorldItem.vue?vue&type=script&lang=js"
script.render = render

export default script